export const DATE_PATTERN = '^(?!00)\\d{1,2}\\.(?!00)\\d{1,2}\\.(?!0...)\\d{4}';

export const BIRTH_CERTIFICATE_RF_PATTERN = {
  FOR_INPUT_MASK: '[ivxlcdmIVXLCDM]{1,7}-[А-Яа-яЁё]{2} [0-9]{6}',
  FOR_VALIDATOR: /(^[IVXLCDM]{1,7}-[А-ЯЁ]{2} \d{6}$)|(^[IVXLCDM]{1,7} [А-ЯЁ]{2} \d{6}$)|(^[IVXLCDM]{1,7}[А-ЯЁ]{2}\d{6}$)/i,
};

export const BIRTH_CERTIFICATE_INTERNATIONAL_PATTERN = {
  FOR_INPUT_MASK:
    '[0-9a-zA-Zа-яА-ЯЁё \\-\\–\\—\\.\\,\\:\\;\\№\\«\\»\\“\\„"\\(\\)/]+',
};

export const PASSPORT_RF_PATTERN = {
  FOR_INPUT_MASK: '[0-9]{2} [0-9]{2} [0-9]{6}',
  FOR_VALIDATOR: /(^[0-9]{2} [0-9]{2} [0-9]{6}$)|(^[0-9]{10}$)/i,
};

export const PHONE_PATTERN = {
  FOR_INPUT_MASK: '+7 (999) 999-99-99',
  FOR_VALIDATOR: /^\+7\s{0,1}\([0-9]{3}\)\s{0,1}[0-9]{3}-[0-9]{2}-[0-9]{2}$/i,
};

export const NAME_PATTERN = {
  FOR_INPUT_MASK: "^[А-Яа-яЁё \\-.—`'’‘IVXLC]+$",
  FOR_VALIDATOR: /^[А-Яа-яЁё \-.—`'’‘IVXLC]+$/i,
};

export const serializePhoneValue = (phone) => {
  if (phone.length === 10) {
    const phoneArr = phone.split('');
    return `+7 (${phoneArr[0]}${phoneArr[1]}${phoneArr[2]}) ${phoneArr[3]}${phoneArr[4]}${phoneArr[5]}-${phoneArr[6]}${phoneArr[7]}-${phoneArr[8]}${phoneArr[9]}`;
  }
  return phone;
};

export const EMAIL_PATTERN = {
  // eslint-disable-next-line
  FOR_VALIDATOR: /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i,
};

export const FLAT_PATTERN = {
  FOR_INPUT_MASK: '[0-9a-zA-Zа-яА-ЯЁё.,-/\\)\\(\\\\]+',
  FOR_VALIDATOR: /^[0-9a-zA-Zа-яА-ЯЁё\.,\-/\\)\\(\\\\]*$/i,
};

export const PATERNITY_PATTERN = {
  FOR_INPUT_MASK:
    '[a-zA-ZА-Яа-яЁё0-9 \\-\\–\\—\\.\\,\\:\\;\\№\\«\\»\\“\\„"\\(\\) ]*',
};
